import { computed } from '@vue/composition-api';
export default (context) => {
    const doctorId = computed(() => context.root.$store.state.Auth.user.doctorId);
    const connectId = computed(() => context.root.$store.state.Auth.user.connectId);
    return [doctorId, connectId];
};
